module.exports = __webpack_public_path__ + "static/Syberia2-5eacdd364047f7cbcbdaf3284b10bb2c.webp";